export const CheckIcon = ({ className = '' }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="checkbox">
        <g clip-path="url(#clip0_11521_196332)">
          <rect
            width="24"
            height="24"
            rx="12"
            transform="matrix(1 0 0 -1 0 24)"
            fill="#DA291C"
          />
          <path
            id="Vector"
            d="M17.9902 9.00008L16.5802 7.58008L9.99023 14.1701L7.41023 11.6001L5.99023 13.0101L9.99023 17.0001L17.9902 9.00008Z"
            fill="white"
          />
        </g>
        <rect
          x="1"
          y="-1"
          width="22"
          height="22"
          rx="11"
          transform="matrix(1 0 0 -1 0 22)"
          stroke="#DA291C"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_11521_196332">
          <rect
            width="24"
            height="24"
            rx="12"
            transform="matrix(1 0 0 -1 0 24)"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
